<template>
  <section class="subscDescriptionWrap">
    <div class="subscDescription">
      <div class="subscDescription__head">
        <span class="subscDescription__head__title">{{ item.menu_title }}</span>
        <span class="subscDescription__head__price">
          月額<b>¥{{ item.price | addComma }}</b>(税込)
        </span>
      </div>
      <dl v-if="paymentMethod" class="subscDescription__payment">
        <dt>お支払い方法</dt>
        <dd>{{ paymentMethod }}</dd>
      </dl>
    </div>
  </section>
</template>


<script>

export default {
  name: 'subscDescription',
  props: {
    item:{
      type: Object,
      default() {
        return {}
      }
    },
    // お支払い方法
    paymentMethod: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.subscDescription{
  background: #FFF7CF;
  border-radius: 7px;
  padding: 15px;
  font-size: 12px;
  line-height: 20px;

  &__head{
    &__title{
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #32373F;
      margin: 0 0 5px;
    }

    &__price{
      display: block;
      font-size: 11px;
      text-align: right;
      color: #4F4F4F;
      b {
        font-size: 18px;
        padding-left: 1px;
      }
    }
  }
  &__payment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 14px 0 0;
    padding: 19px 0 5px;
    border-top: 1px solid #E3D6CA;
    color: #32373F;
    dt {
    }
    dd {
      margin: 0;
      font-size: 11px;
      font-weight: bold;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/SubscDescriptionChoun.vue